import { Field, ImageField, LinkField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type IntroSectionItemProps = {
  title: TextField;
  icon: ImageField;
  link: LinkField;
  iconDropList: Field<string>;
  buttonAriaLabel?: Field<string>;
  id: string;
};
export type IntroSectionFields = {
  eyebrowText: TextField;
  title: TextField;
  description: TextField;
  items: IntroSectionItemProps[];
  numberOfColumns?: Field<string>;
  dataSource: {
    Title: Field<string>;
    Header: Field<string>;
    Text: Field<string>;
  };
  dataSourceShared: {
    Title: Field<string>;
    Header: Field<string>;
    Text: Field<string>;
  };
  textGradient?: Field<string>;
  descriptionFontSize?: Field<string>;
  textShadow?: Field<boolean>;
};
